import { motion } from "framer-motion";

const transition = (OgComponent) => {
    return () => (
        <>
            <OgComponent />
            <motion.div
                className='slide-in'
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 0 }}
                exit={{ scaleX: 1 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.div
                className='slide-out'
                initial={{ scaleX: 1 }}
                animate={{ scaleX: 0 }}
                exit={{ scaleX: 0 }}
                transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.img
                src="/images/cgfed-logo.png"
                alt=""
                className="transition-logo"
                initial={{ opacity: 0, scale: 0.6, x: '-50%', y: '-50%' }}
                animate={{ opacity: 0, scale: 0.6, x: '-50%', y: '-50%' }}
                exit={{ opacity: 1, scale: 1, x: '-50%', y: '-50%', transition: { duration: 0.3, delay: 0.2 } }}
            />
            <motion.img
                src="/images/cgfed-logo.png"
                alt=""
                className="transition-logo"
                initial={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
                animate={{ opacity: 0, scale: 0.6, x: '-50%', y: '-50%', transition: { duration: 0.3 } }}
                exit={{ opacity: 0, scale: 0.6, x: '-50%', y: '-50%' }}
            />
        </>
    );
};

export default transition;
